'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var hqoTheme = require('./hqo-theme-587e766d.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./enums-de2d9d36.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
var index$1 = require('./index-c3c373ce.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
var useOnClickOutside_hook = require('./use-on-click-outside.hook-0ab21de9.js');
var useAbsolutePositionRefDetails_hook = require('./use-absolute-position-ref-details.hook-82555fac.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
var paper = require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
var component$4 = require('./component-39a54733.js');
var statusIndicator = require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var ReactDOM = _interopDefault(require('react-dom'));

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  padding: 8px 16px;\n  margin-bottom: ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n\n  &.active,\n  &.active:hover {\n    background: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  display: flex;\n  padding: 8px 16px;\n  margin-bottom: ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n\n  &.active,\n  &.active:hover {\n    background: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (_a) {
    var lastItem = _a.lastItem;
    return (lastItem ? '0' : '8px');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var Text = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin: 0;\n  font-weight: ", ";\n  width: 100%;\n"], ["\n  margin: 0;\n  font-weight: ", ";\n  width: 100%;\n"])), function (_a) {
    var hasLabelHint = _a.hasLabelHint;
    return (hasLabelHint ? 500 : 400);
});
var Icon = styled__default.span(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-right: 4px;\n"], ["\n  margin-right: 4px;\n"])));
var Hint = styled__default.p(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font-weight: 400;\n  font-size: 12px;\n  margin: 0;\n  color: ", ";\n"], ["\n  font-weight: 400;\n  font-size: 12px;\n  margin: 0;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var DropdownItem = function (_a) {
    var _b;
    var active = _a.active, item = _a.item, lastItem = _a.lastItem, onSelect = _a.onSelect, _c = _a.withStatus, withStatus = _c === void 0 ? false : _c;
    var handleClick = React.useCallback(function () {
        onSelect(item);
    }, [item, onSelect]);
    var className = (_b = item.props) === null || _b === void 0 ? void 0 : _b.className;
    return (React__default.createElement(Container, { lastItem: lastItem, onClick: handleClick, "data-testid": "hqo-dropdown-item", "data-cy": "hqo-dropdown-item", className: index$1.classnames('menu-item', className, { active: active }) }, withStatus ? (React__default.createElement(statusIndicator.StatusIndicator, { label: item.label, color: item.indicatorColor, variant: item.indicatorVariant, version: item === null || item === void 0 ? void 0 : item.version })) : (React__default.createElement(React__default.Fragment, null,
        item.icon && React__default.createElement(Icon, null, item.icon),
        React__default.createElement(Text, { hasLabelHint: Boolean(item.labelHint) },
            item.label,
            item.labelHint && React__default.createElement(Hint, null, item.labelHint))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var DropdownInfiniteLoaderContainer = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  padding-top: 4px;\n  padding-bottom: 8px;\n  background: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  padding-top: 4px;\n  padding-bottom: 8px;\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.colors.universal.white);
});
var templateObject_1$1;

var DropdownInfiniteLoader = function () { return (React__default.createElement(DropdownInfiniteLoaderContainer, { "data-testid": "dropdown-infinite-loader-container" },
    React__default.createElement(component$4.Spinner, { color: hqoTheme.colors.floorPlan.blue, size: "32px" }))); };

var DropdownOptions = function (_a) {
    var options = _a.options, onSelect = _a.onSelect, value = _a.value, withStatus = _a.withStatus, infiniteLoading = _a.infiniteLoading;
    return (React__default.createElement(React__default.Fragment, null,
        options.map(function (option, optionPosition) {
            var isActiveOption = option.label === value;
            var isLastItem = options.length - 1 === optionPosition && !infiniteLoading;
            return (React__default.createElement(DropdownItem, { active: isActiveOption, item: option, key: option.value || option.label, lastItem: isLastItem, onSelect: onSelect, withStatus: withStatus }));
        }),
        infiniteLoading && (React__default.createElement(DropdownInfiniteLoader, null))));
};

var MAX_DROPDOWN_HEIGHT = 272;

var Container$1 = styled__default.div(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  position: ", ";\n"], ["\n  width: 100%;\n  position: ", ";\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? 'relative' : 'static');
});
var activeStyles = {
    true: styled.css(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n    border: 1px solid ", ";\n  "], ["\n    border: 1px solid ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    false: styled.css(templateObject_3$1 || (templateObject_3$1 = tslib_es6.__makeTemplateObject(["\n    border: 1px solid transparent;\n  "], ["\n    border: 1px solid transparent;\n  "]))),
};
var disabledStyled = styled.css(templateObject_4$1 || (templateObject_4$1 = tslib_es6.__makeTemplateObject(["\n  &.field {\n    background-color: ", ";\n    color: ", ";\n    pointer-events: none;\n  }\n"], ["\n  &.field {\n    background-color: ", ";\n    color: ", ";\n    pointer-events: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
});
var errorStyle = styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var ValueContainer = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-radius: 4px;\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-radius: 4px;\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return activeStyles[active];
}, function (_a) {
    var errored = _a.errored;
    return errored && errorStyle;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && disabledStyled;
});
var Value = styled__default.p(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  margin: 0;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  max-width: 95%;\n  max-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  margin: 0;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  max-width: 95%;\n  max-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Placeholder = styled__default(Value)(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMediumAlt;
});
var StyledPaper = styled__default(paper.Paper)(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n  margin-top: 8px;\n  padding: 8px 0;\n  overflow: auto;\n  position: absolute;\n  max-height: ", ";\n  height: auto;\n"], ["\n  margin-top: 8px;\n  padding: 8px 0;\n  overflow: auto;\n  position: absolute;\n  max-height: ", ";\n  height: auto;\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight || MAX_DROPDOWN_HEIGHT + "px";
});
var Overlay = styled__default.div(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  inset: 0;\n"], ["\n  position: fixed;\n  z-index: ", ";\n  inset: 0;\n"])), function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
});
var Arrow = styled__default.span(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  pointer-events: none;\n"], ["\n  color: ", ";\n  pointer-events: none;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledPortalPaper = styled__default(StyledPaper)(templateObject_12 || (templateObject_12 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  max-width: 100%;\n  width: auto;\n  min-width: ", "px;\n  margin: 0;\n"], ["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  max-width: 100%;\n  width: auto;\n  min-width: ", "px;\n  margin: 0;\n"])), function (_a) {
    var top = _a.top;
    return top;
}, function (_a) {
    var left = _a.left;
    return left;
}, function (_a) {
    var containerWidth = _a.containerWidth;
    return containerWidth;
});
var Dropdown = function (_a) {
    var onSelect = _a.onSelect, options = _a.options, placeholder = _a.placeholder, value = _a.value, _b = _a.isPortal, isPortal = _b === void 0 ? false : _b, _c = _a.zIndexOverlay, zIndexOverlay = _c === void 0 ? constants.ZINDEX.MODAL_BACKGROUND : _c, className = _a.className, fieldClass = _a.fieldClass, withStatus = _a.withStatus, _d = _a.closeOnSelect, closeOnSelect = _d === void 0 ? true : _d, errored = _a.errored, handleErrored = _a.handleErrored, infiniteLoading = _a.infiniteLoading, handleOnScrollCallback = _a.handleOnScrollCallback, maxMenuHeight = _a.maxMenuHeight, props = tslib_es6.__rest(_a, ["onSelect", "options", "placeholder", "value", "isPortal", "zIndexOverlay", "className", "fieldClass", "withStatus", "closeOnSelect", "errored", "handleErrored", "infiniteLoading", "handleOnScrollCallback", "maxMenuHeight"]);
    var _e = useBooleanState_hook.useBooleanState(false), isActive = _e.value, toggleActive = _e.toggle, setFalse = _e.setFalse;
    var ref = React.useRef(null);
    var divRef = React.useRef(null);
    useOnClickOutside_hook.useOnClickOutside(function () {
        setFalse();
        if (handleErrored) {
            handleErrored();
        }
        if (props === null || props === void 0 ? void 0 : props.onBlur) {
            props.onBlur();
        }
    }, [ref, divRef]);
    var handleOnSelect = React.useCallback(function (option) {
        onSelect(option);
        if (closeOnSelect) {
            setFalse();
        }
    }, [onSelect, setFalse, closeOnSelect]);
    var position = useAbsolutePositionRefDetails_hook.useAbsolutePositionRefDetails({
        isActive: isActive,
        isPortal: isPortal,
        ref: ref,
        divRef: divRef,
    });
    var renderOptions = (React__default.createElement(DropdownOptions, { onSelect: handleOnSelect, options: options, value: value, withStatus: withStatus, infiniteLoading: infiniteLoading }));
    var handleOnScroll = React.useCallback(function (event) {
        if (handleOnScrollCallback) {
            handleOnScrollCallback(event);
        }
    }, [handleOnScrollCallback]);
    var renderDrop = function () {
        var dropProps = {
            depth: 2,
            borderRadius: 'sm',
            'data-testid': 'hqo-dropdown-options',
            'data-cy': 'hqo-dropdown-options',
            ref: divRef,
        };
        var onScroll = handleOnScrollCallback ? handleOnScroll : undefined;
        if (!isPortal) {
            return (React__default.createElement(StyledPaper, tslib_es6.__assign({ className: "menu" }, dropProps, { onScroll: onScroll, maxHeight: maxMenuHeight }), renderOptions));
        }
        return ReactDOM.createPortal(React__default.createElement(Overlay, { "data-testid": "hqo-dropdown-overlay", zIndex: zIndexOverlay },
            React__default.createElement(StyledPortalPaper, tslib_es6.__assign({ className: "menu" }, dropProps, position, { onScroll: onScroll, maxHeight: maxMenuHeight }), renderOptions)), document.body);
    };
    return (React__default.createElement(Container$1, tslib_es6.__assign({ "data-testid": "hqo-dropdown", "data-cy": "hqo-dropdown", isActive: isActive, errored: errored, className: className }, props),
        React__default.createElement(ValueContainer, tslib_es6.__assign({ ref: ref, active: isActive.toString(), onClick: toggleActive, "data-testid": "hqo-dropdown-value-container", "data-cy": "hqo-dropdown-value-container", className: fieldClass, errored: errored, "data-isopen": isActive }, props),
            value && React__default.createElement(Value, { className: "field-value" }, value),
            !value && placeholder && React__default.createElement(Placeholder, { className: "field-placeholder" }, placeholder),
            React__default.createElement(Arrow, { className: "material-icons", "data-testid": "caret-" + (isActive ? 'up' : 'down') + "-sharp", "data-cy": "caret-" + (isActive ? 'up' : 'down') + "-sharp" }, isActive ? 'arrow_drop_up' : 'arrow_drop_down')),
        isActive && renderDrop()));
};
var templateObject_1$2, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;

exports.Arrow = Arrow;
exports.Dropdown = Dropdown;
